/**
 * Unique idenifiers for questions -- need to add at least one value for each type of question here
 */
export enum ReportQuestion {
	// What is near the location
	NearToLocation = 'NearToLocation', // Has note

	CallerType = 'CallerType', // make it callerType one for police fire and customer

	ContactName = 'ContactName', // Has note
	ContactPhone = 'ContactPhone', // Has note

	// TODO: for now Name / Badge ID is just as relabeled Contact Name
	// PoliceFireBadgeNumber = 'PoliceFireBadgeNumber',
	PoliceFirePIN = 'PoliceFirePIN', // Has note

	ProblemType = 'ProblemType', // Used for flow

	EmergencyType = 'EmergencyType', // Used for flow
	Emergencies = 'Emergencies',
	EmergencyResponse = 'EmergencyResponse', // Has note

	EquipmentContact = 'EquipmentContact', // Has note
	EquipmentContactTime = 'EquipmentContactTime', // Has note
	EquipmentContactLocationDetails = 'EquipmentContactLocationDetails', // Has note

	PublicTrappedBy = 'PublicTrappedBy', // Has note

	InjuredPersonLocation = 'InjuredPersonLocation', // Has note

	// TODO: this should probably be represented as a category
	// Use for flow rather than as a symptom
	FireType = 'FireType',
	Fire = 'Fire', // Has note
	Arcing = 'Arcing', // Has note

	EquipmentIssue = 'EquipmentIssue',
	ObjectOnWire = 'ObjectOnWire', // Has note
	WireOnObject = 'WireOnObject', // Has note
	PoleIssue = 'PoleIssue', // Has note
	PoleType = 'PoleType', // Has note

	DownWireLocation = 'DownWireLocation', // Has note

	// Use this to differentiate options selected based on flow vs. the actual problem
	PowerIssueType = 'PowerIssueType', // Used for flow

	PowerIssue = 'PowerIssue', // Has note
	PowerIssueTime = 'PowerIssueTime', // Has note
	PowerIssueReportedBefore = 'PowerIssueReportedBefore', // Has note

	AppliancesWithoutPower = 'AppliancesWithoutPower', // Has note
	CheckedBreakers = 'CheckedBreakers', // Has note
	Generator = 'Generator', // Has note
	NeighborsOut = 'NeighborsOut', // Has note
	RecentElectricalWork = 'RecentElectricalWork', // Has note
	FurnaceWorking = 'FurnaceWorking', // Has note
	FireSmokeBurningSmell = 'FireSmokeBurningSmell', // Has note

	HazardIssueType = 'HazardIssueType', // Used for flow
	HazardDescription = 'HazardDescription', // Has note
	TransformerType = 'TransformerType', // Has note
	HazardAccessibleToPublic = 'HazardAccessibleToPublic', // Has note

	WireType = 'WireType', // Has note

	OverheadWireIssue = 'OverheadWireIssue', // Has note
	OverheadWireDisconnectedFrom = 'OverheadWireDisconnectedFrom', // Has note
	TransformerIssue = 'OverheadTransformerIssue', // Has note

	UndergroundWireIssue = 'UndergroundWireIssue', // Has note

	ExcavationDamage = 'ExcavationDamage', // Has note
	ExcavationDamageResponsibleParty = 'ExcavationDamageResponsibleParty', // Has note

	DisconnectRequested = 'DisconnectRequested',
	DisconnectElectric = 'DisconnectElectric',

	Manhole = 'Manhole', // Has note
	ManholeLocationDetails = 'ManholeLocationDetails', // Has note

	Debris = 'Debris', // Has note
	DebrisType = 'DebrisType', // Used for flow
	DebrisIssueTime = 'DebrisIssueTime', // Has note

	NotificationType = 'NotificationType', // Used for Flow
	EmailNotifications = 'EmailNotifications', // Notification values aren't included in notes
	SmsNotifications = 'SmsNotifications', // Notification values aren't included in notes

	// Any attachments
	Attachments = 'Attachments', // Not used in current CR flow

	// TODO: if we convert from V2 to V3, we need to add a new question for voice notifications

	Observations = 'Observations', // Observations aren't included in notes
	Notes = 'Notes',
	LocationDescription = 'LocationDescription',

	// GLN questions
	CompanyName = 'CompanyName', // Has note
	GLNProblemType = 'GLNProblemType', // Used for flow
	GLNServiceType = 'GLNServiceType', // Has note

	// Location information
	GLNLocation = 'GLNLocation', // Has note
	CrossStreetLocation = 'CrossStreetLocation', // Has note

	// TODO: These are for Street Light / OPL and will be used later
	LightIssue = 'LightIssue',
	LightCount = 'LightCount',
	LightLocation = 'LightLocation',
	RequireShieldRotated = 'RequireShieldRotated',
	PoleSerialNumber = 'PoleSerialNumber',
}

/**
 * Answers that may be common across multiple questions
 */
export enum StandardAnswerValue {
	Other = 'Other',
	None = 'None',
	Yes = 'Yes',
	No = 'No',
	Unknown = 'Unknown',
	Value = 'Value',
}

/**
 * TODO: create an entry for each of the questions in the CR reporting flow
 *
 * For each we should have:
 * 1. A entry in this enum
 * 2. A enum with the possible values for that question (if the value is something other than a freeform string)
 * 3. Interface that extends ReportAnswer with the specific values for this question
 * 4. A function that maps from V2 to V3
 */
